import {Alert, Box, Typography} from '@mui/material'
import {ArrayInput, SelectInput, SimpleFormIterator, TextInput} from 'react-admin'
import React from 'react'

export default function FieldsContact() {

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Typography variant="h6" gutterBottom>Informations de contact</Typography>
            <Alert severity="warning" style={{width: '100%', marginBottom: 20}}>Attention à bien
                remplir les informations de contact</Alert>
            <TextInput
                label="Email"
                name="email"
                source="email"
                fullWidth
            />
            <TextInput
                label="Téléphone"
                name="phone"
                source="phone"
                fullWidth
            />
            <TextInput
                label="Site web"
                name="website"
                source="website"
                fullWidth
            />
            <ArrayInput
                name="social"
                source="social"
                label="Réseaux sociaux"
            >
                <SimpleFormIterator inline>
                    <SelectInput source="name" choices={[
                        {id: 'facebook', name: 'Facebook'},
                        {id: 'instagram', name: 'Instagram'},
                        {id: 'twitter', name: 'Twitter'}
                    ]}/>
                    <TextInput source="url"/>
                </SimpleFormIterator>
            </ArrayInput>
        </Box>
    )
}
